import comp from "./LockingStateLabelComponent";
export default comp;
